// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tq-custom-radio-buttons{width:100%;display:block!important}.tq-custom-radio-buttons label{width:100%;display:block}.grid-2-col{display:grid;grid-template-columns:repeat(2,50%)}.loader{display:flex;align-items:flex-end;margin-left:10px}", ""]);
// Exports
module.exports = exports;
